module.exports = __webpack_public_path__ + "img/course-bac.889d75da.gif";